(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  window.VroliseMotion = { reduced: reduced, keyboard: false };
  document.addEventListener('keydown', function (event) {
    if (event.metaKey || event.ctrlKey || event.altKey) return;
    window.VroliseMotion.keyboard = true;
    document.documentElement.setAttribute('data-vr-keyboard', '');
  }, true);
  document.addEventListener('pointerdown', function () {
    window.VroliseMotion.keyboard = false;
    document.documentElement.removeAttribute('data-vr-keyboard');
  }, true);
  var F = window.Flickity;
  if (!F) return;
  var p = F.prototype, instances = new Set();
  var original = {};
  ['_create', 'select', 'startAnimation', 'animate', 'bindDrag', 'unbindDrag', 'playPlayer', 'unpausePlayer'].forEach(function (name) {
    original[name] = p[name];
  });

  function managed(f) {
    return f.element.matches('.Product__Slideshow') ||
      (!f.options.wrapAround && f.element.matches('.ProductList--carousel'));
  }
  function stop(f) {
    cancelAnimationFrame(f.vrFrame);
    f.vrFrame = 0;
    f.vrPrevious = 0;
    f.isAnimating = false;
    f.slider.style.willChange = '';
  }
  function fade(f) {
    if (f.vrFade) f.vrFade.cancel();
    f.vrFade = f.viewport.animate([{ opacity: .55 }, { opacity: 1 }], {
      duration: 120, easing: 'ease-out'
    });
  }
  function finish(f) {
    stop(f);
    f.velocity = 0;
    f.positionSliderAtSelected();
    f.dispatchEvent('settle');
  }
  function nearest(f, projected) {
    var best = f.selectedIndex, distance = Infinity;
    f.slides.forEach(function (slide, index) {
      var cycle = f.options.wrapAround && f.slideableWidth > 0 ?
        Math.round((-projected - slide.target) / f.slideableWidth) : 0;
      var delta = Math.abs(projected + slide.target + cycle * f.slideableWidth);
      if (delta < distance) { distance = delta; best = index + cycle * f.slides.length; }
    });
    return best;
  }
  function rubber(f, value) {
    if (f.options.wrapAround || !f.slides.length) return value;
    var upper = -f.slides[0].target, lower = -f.getLastSlide().target;
    var boundary = Math.max(lower, Math.min(upper, value));
    var overshoot = value - boundary, width = Math.max(1, f.size.innerWidth);
    return boundary + overshoot * width * .55 / (width + .55 * Math.abs(overshoot));
  }
  function sample(held, value, time) {
    held.samples.push({ x: value, time: time });
    held.samples = held.samples.filter(function (point) { return time - point.time <= 80; });
  }
  function speed(held) {
    var first = held.samples[0], last = held.samples[held.samples.length - 1];
    return last.time > first.time ? (last.x - first.x) * 1000 / (last.time - first.time) : 0;
  }
  function releaseCapture(f, held) {
    if (f.viewport.hasPointerCapture(held.id)) f.viewport.releasePointerCapture(held.id);
  }
  function cancelDrag(f) {
    var held = f.vrDrag;
    if (!held) return;
    f.vrDrag = null;
    f.isPointerDown = false;
    f.isDragging = false;
    f.viewport.classList.remove('is-pointer-down');
    releaseCapture(f, held);
  }
  function tick(f, now) {
    f.vrFrame = 0;
    if (!f.isActive || !f.selectedSlide || f.vrDrag) { stop(f); return; }
    if (reduced.matches) { finish(f); return; }
    var dt = Math.max(0, (now - f.vrPrevious) / 1000);
    f.vrPrevious = now;
    var target = -f.selectedSlide.target, offset = f.x - target;
    var omega = 2 * Math.PI / .4, ratio = f.vrMomentum ? .8 : 1;
    var a = ratio * omega, decay = Math.exp(-a * dt), v = f.velocity;
    if (ratio === 1) {
      var b = v + omega * offset;
      f.x = target + (offset + b * dt) * decay;
      f.velocity = (v - omega * b * dt) * decay;
    } else {
      var frequency = omega * Math.sqrt(1 - ratio * ratio);
      var sin = Math.sin(frequency * dt), cos = Math.cos(frequency * dt);
      f.x = target + decay * (offset * cos + (v + a * offset) / frequency * sin);
      f.velocity = decay * (v * cos - (a * v + omega * omega * offset) / frequency * sin);
    }
    f.positionSlider();
    if (Math.abs(f.x - target) < .1 && Math.abs(f.velocity) < 1) { finish(f); return; }
    f.vrFrame = requestAnimationFrame(function (time) { tick(f, time); });
  }

  p._create = function () {
    instances.add(this);
    this.vrManaged = managed(this);
    original._create.apply(this, arguments);
    var f = this;
    f.on('deactivate', function () { cancelDrag(f); stop(f); if (f.vrFade) f.vrFade.cancel(); });
    f.on('resize', function () { cancelDrag(f); if (f.vrManaged && f.isActive) finish(f); });
    f.on('destroy', function () { instances.delete(f); });
    if (reduced.matches) f.stopPlayer();
  };
  p.select = function (index, wrap, instant) {
    if (window.VroliseMotion.keyboard) {
      instant = true;
      if (this.vrFade) this.vrFade.cancel();
    }
    var changed = this.isInitActivated && index !== this.selectedIndex;
    if (this.vrManaged) {
      cancelDrag(this);
      if (!this.vrReleasing) this.vrMomentum = false;
      if (instant || reduced.matches) { stop(this); this.velocity = 0; }
    }
    if (reduced.matches) { this.isAnimating = false; this.velocity = 0; }
    original.select.call(this, index, wrap, instant || reduced.matches);
    if (reduced.matches && changed && !instant && this.isActive) fade(this);
  };
  p.startAnimation = function () {
    if (reduced.matches) { finish(this); return; }
    if (!this.vrManaged) return original.startAnimation.apply(this, arguments);
    if (this.vrFrame) return;
    this.isAnimating = true;
    this.vrPrevious = performance.now();
    this.slider.style.willChange = 'transform';
    var f = this;
    this.vrFrame = requestAnimationFrame(function (time) { tick(f, time); });
  };
  p.animate = function () {
    if (reduced.matches) { finish(this); return; }
    return original.animate.apply(this, arguments);
  };
  ['playPlayer', 'unpausePlayer'].forEach(function (name) {
    p[name] = function () {
      if (reduced.matches) { this.stopPlayer(); return; }
      return original[name].apply(this, arguments);
    };
  });
  p.bindDrag = function () {
    if (!this.vrManaged) return original.bindDrag.apply(this, arguments);
    if (!this.options.draggable || this.isDragBound || !window.PointerEvent) return;
    var f = this, viewport = f.viewport;
    f.isDragBound = true;
    f.element.classList.add('is-draggable');
    f.element.setAttribute('data-vr-pointer-rail', '');
    viewport.style.touchAction = 'pan-y pinch-zoom';
    function down(event) {
      if (!event.isPrimary || event.button !== 0 || f.vrDrag ||
          event.target.closest('button, input, select, textarea')) return;
      f.vrSuppressClick = false;
      stop(f);
      f.vrDrag = { id: event.pointerId, startX: event.clientX, startY: event.clientY,
        origin: f.x, active: false, event: event, samples: [{ x: f.x, time: event.timeStamp }] };
      f.isPointerDown = true;
      viewport.classList.add('is-pointer-down');
      f.dispatchEvent('pointerDown', event, [event]);
    }
    function move(event) {
      var held = f.vrDrag;
      if (!held || held.id !== event.pointerId) return;
      var dx = event.clientX - held.startX, dy = event.clientY - held.startY;
      if (!held.active) {
        var threshold = f.element.matches('.Product__Slideshow') ? 10 : f.options.dragThreshold;
        if (Math.hypot(dx, dy) < threshold) return;
        if (Math.abs(dy) > 1.2 * Math.abs(dx)) {
          cancelDrag(f);
          f.startAnimation();
          return;
        }
        if (Math.abs(dx) < 1.2 * Math.abs(dy)) return;
        held.active = true;
        f.isDragging = true;
        viewport.setPointerCapture(event.pointerId);
        f.dispatchEvent('dragStart', event, [event]);
      }
      event.preventDefault();
      var direction = f.options.rightToLeft ? -1 : 1;
      held.position = rubber(f, held.origin + dx * direction);
      sample(held, held.position, event.timeStamp);
      if (!reduced.matches) {
        f.x = held.position;
        f.velocity = speed(held);
        if (!f.vrFrame) f.vrFrame = requestAnimationFrame(function () {
          f.vrFrame = 0;
          f.positionSlider();
        });
      }
      f.dispatchEvent('pointerMove', event, [event, { x: dx, y: dy }]);
      f.dispatchEvent('dragMove', event, [event, { x: dx, y: dy }]);
    }
    function up(event, cancelled) {
      var held = f.vrDrag;
      if (!held || held.id !== event.pointerId) return;
      if (held.active && !cancelled) move(event);
      cancelDrag(f);
      stop(f);
      f.dispatchEvent('pointerUp', event, [event]);
      if (!held.active) {
        if (!cancelled) f.staticClick(held.event, event);
        f.startAnimation();
        return;
      }
      f.vrSuppressClick = true;
      var value = held.position === undefined ? f.x : held.position;
      sample(held, value, event.timeStamp);
      var velocity = cancelled || reduced.matches ? 0 : speed(held);
      var projected = value + velocity / 1000 * .998 / (1 - .998);
      var index = cancelled ? f.selectedIndex : nearest(f, projected);
      if (!f.options.wrapAround && f.slides.length) {
        if (value > -f.slides[0].target) index = 0;
        if (value < -f.getLastSlide().target) index = f.slides.length - 1;
      }
      f.velocity = velocity;
      f.vrMomentum = velocity !== 0;
      f.vrReleasing = true;
      f.isDragSelect = !!f.options.wrapAround;
      if (f.options.wrapAround && f.slides.length > 1) {
        var cycle = Math.floor(index / f.slides.length);
        f.x += cycle * f.slideableWidth;
        index = ((index % f.slides.length) + f.slides.length) % f.slides.length;
      }
      f.select(index);
      delete f.isDragSelect;
      f.vrReleasing = false;
      f.dispatchEvent('dragEnd', event, [event]);
    }
    var handlers = {
      pointerdown: down,
      pointermove: move,
      pointerup: function (event) { up(event, false); },
      pointercancel: function (event) { up(event, true); },
      lostpointercapture: function (event) { if (event.target === viewport) up(event, true); },
      pointerleave: function (event) { if (f.vrDrag && !f.vrDrag.active) up(event, true); },
      dragstart: function (event) { event.preventDefault(); },
      click: function (event) {
        if (!f.vrSuppressClick || event.detail === 0) return;
        f.vrSuppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    f.vrHandlers = handlers;
    Object.keys(handlers).forEach(function (name) { viewport.addEventListener(name, handlers[name], { passive: false }); });
  };
  p.unbindDrag = function () {
    if (!this.vrManaged) return original.unbindDrag.apply(this, arguments);
    cancelDrag(this);
    stop(this);
    var f = this;
    Object.keys(f.vrHandlers || {}).forEach(function (name) { f.viewport.removeEventListener(name, f.vrHandlers[name]); });
    f.vrHandlers = null;
    f.isDragBound = false;
    f.element.classList.remove('is-draggable');
    f.element.removeAttribute('data-vr-pointer-rail');
    f.viewport.style.touchAction = '';
  };
  reduced.addEventListener('change', function () {
    if (!reduced.matches) return;
    instances.forEach(function (f) {
      cancelDrag(f);
      stop(f);
      f.stopPlayer();
      if (f.vrFade) f.vrFade.cancel();
      if (f.isActive) finish(f);
    });
  });
})();
